import React, { useEffect } from 'react';
import { useI18n } from '@olxeu-a2b/ui/src/i18n';
import { RadioLight } from '@nexus/lib-react/dist/core/Radio/RadioLight';
import ButtonPrimaryDark from '@nexus/lib-react/dist/core/Button/ButtonPrimaryDark';
import { useTrackEvent } from '@olxeu-a2b/delivery-utils/src/tracking/useNinja';
import { FAKE_DOOR_TRACKING_KEYS } from './constants';
import { BenefitsProps, ListProps } from './types';
import S from './style';

const Benefits: React.FC<BenefitsProps> = ({
  items,
  userId,
  selected,
  sessionCookie,
  handleSubmit,
  handleBenefitChange,
}) => {
  const i18n = useI18n();
  const trackEvent = useTrackEvent();

  const benefitsList = ({ type, icon }: ListProps) => {
    const isSelected: boolean = type === selected;
    return (
      <S.BenefitItem key={type} selected={isSelected} onClick={() => handleBenefitChange(type)}>
        <S.ItemWrapper>
          <S.Icon>{icon}</S.Icon>
          <S.Title>{i18n(`dlv_benefits_challenge_${type}_title`)}</S.Title>
          <S.Description>{i18n(`dlv_benefits_challenge_${type}_description`)}</S.Description>
          <S.RadioButton data-testid="benefits-radio-button">
            <RadioLight id={type} checked={isSelected} />
          </S.RadioButton>
        </S.ItemWrapper>
      </S.BenefitItem>
    );
  };

  useEffect(() => {
    trackEvent(FAKE_DOOR_TRACKING_KEYS.mailClick, null, null, {
      user_id: userId,
      session_long: sessionCookie,
    });

    trackEvent(FAKE_DOOR_TRACKING_KEYS.pageView, null, null, {
      user_id: userId,
      session_long: sessionCookie,
      delivery_challenge_user: userId,
    });
  }, []);

  return (
    <S.PageWrapper>
      <S.InfoBlock>
        <S.PageTitle>{i18n`dlv_benefits_challenge_title`}</S.PageTitle>
        <S.PageDescription>{i18n`dlv_benefits_challenge_description`}</S.PageDescription>
      </S.InfoBlock>

      <S.BenefitsWrapper>{items.map(benefitsList)}</S.BenefitsWrapper>

      <S.ButtonBlock>
        <ButtonPrimaryDark
          onClick={handleSubmit}
          disabled={!selected}
          data-testid="benefits-submit-button"
        >
          {i18n`dlv_benefits_challenge_button_label`}
        </ButtonPrimaryDark>
      </S.ButtonBlock>

      <S.Disclaimer>{i18n`dlv_benefits_challenge_disclaimer`}</S.Disclaimer>
    </S.PageWrapper>
  );
};

export default Benefits;
